export const DEFAULT_AVATAR = 'https://secure.gravatar.com/avatar/f7219bbd71f453e41750fa3c63a11da1?size=64&default=mm'
